// web/src/pages/external/ExternalStatementViewPage.tsx
import { useParams } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { externalApi } from "@/lib/external";
import { StatementPdfFrame } from "@/components/clients-accounts";

const fmt = new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" });

export function ExternalStatementViewPage() {
  const { token = "" } = useParams();
  const { data: view, isLoading, error } = useQuery({
    queryKey: ["external-stmt", token], queryFn: () => externalApi.getStatement(token), retry: false,
  });

  if (isLoading) return <p className="p-8 text-center">Loading…</p>;
  if (error)
    return (
      <div className="p-8 text-center">
        <h1 className="text-xl font-semibold mb-2">Link not available</h1>
        <p className="text-muted-foreground">{(error as Error).message}</p>
      </div>
    );

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-4">
      <header className="border-b pb-3">
        <h1 className="text-xl font-semibold">Statement {view!.statementNo}</h1>
        <p className="text-sm text-muted-foreground">
          Account {view!.accountReferenceNo} · {new Date(view!.statementDate).toLocaleDateString("en-AU")}
        </p>
        <p className="mt-1">Closing balance: <strong>{fmt.format(view!.closingBalance)}</strong></p>
      </header>
      <StatementPdfFrame src={view!.pdfDownloadUrl} title={`Statement ${view!.statementNo}`} />
    </div>
  );
}
